<template>
  <div class="getback-contain">
    <van-cell class="getback-contain">
      <template #title>
        <div class="custom-title" @click="getBackPage"><van-icon name="arrow-left" size="20" color="#fff"/></div>
    </template>
  </van-cell>
  </div>
</template>
<script>
export default {
  methods: {
    getBackPage() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
  .getback-contain{
    width: 100%;
    // height: 2rem;
    background-color: $primary-color;
    border-color: $primary-color;
    // padding: 0.1rem;
    // box-sizing: border-box;
  }
</style>